import Layout from '@/components/layout/index.vue'
//权限管理
export default [
    {
        path: '/',
        name: 'authorityLayout',
        component: Layout,
        meta: {
            title: '管理权限',
        },
        children: [
            {
                path: '/authority/rulelist',
                name: 'rulelist',
                meta: {
                    title: '权限管理',
                },
            },
            {
                path: '/authority/rolelist',
                meta: {
                    title: '角色管理',
                },
                component: () => import('@/views/authority/role/rolelist'),
            },
            {
                path: '/authority/accountlist',
                name: 'accountlist',
                meta: {
                    title: '员工管理',
                },
                component: () =>
                    import('@/views/authority/account/accountlist'),
            },
        ],
    },
]
